export const gameType = {
  PETS: {
    NAME: 'PETS',
    ATLAS: 'pyx-pets-sprites',
    ATLAS_PATH: 'game-data/pyx-pets-sprites/pyx-pets-sprites.json',
    ASSET_LOCATION: 'game-data/pyx-pets-sprites/',
  },
};
